<!--
 * @Author: 汪永康 wangyongkang@yxj.org.cn
 * @Date: 2024-07-01 10:24:28
 * @LastEditors: 汪永康 wangyongkang@yxj.org.cn
 * @LastEditTime: 2024-08-05 16:25:25
 * @FilePath: \ysz_web_international\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <div class="content_box">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data () {
    return {
    }
  },
  mounted () {
    /**
     * 已停用「按视口宽度动态 setRem」：Ctrl+/- 缩小时 layout 变宽，再按比例放大 html 字号
     * 会与浏览器缩放叠加，约 80% 以下根字号过大、易崩；大屏同样不可靠。
     * 缩放到 25% 交给浏览器统一处理。大屏可读性可用下方 @media 微调 html 字号。
     */
    document.documentElement.style.fontSize = '';
  },
  watch: {

  }
}
</script>

<style>
.ysz-ueditor-title-three-zsj::before {
  content: "";
  display: inline-block;
  width: 0.433333rem;
  height: 0.433333rem;
  background-color: #000;
  border-radius: 50%;
  margin: 0 0.3rem 0 0.6rem;
}
/* p:has(.ysz-ueditor-title-three-zsj) {
    margin: 0;
    padding: 0;
} */
body {
  padding: 0 !important;
}
html {
  font-size: 16px;
  word-spacing: 1px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
  overflow-x: auto;
}
/* 大屏略增根字号（纯 CSS，不随 Ctrl+/- 去算 innerWidth，避免与浏览器缩放打架） */
@media (min-width: 2200px) {
  html {
    font-size: 18px;
  }
}
@media (min-width: 3000px) {
  html {
    font-size: 20px;
  }
}

*,
*:before,
*:after {
  box-sizing: border-box;
  margin: 0;
}

.scroll {
  position: relative;
}

.content_box {
  width: 100%;
  margin-top: 0;
  min-height: auto;
}



</style>
